// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6f69c8b4","239":"37da6194","455":"dbf4b015"}[chunkId] + ".chunk.js";
};